import type { QueryResultType } from "@rocicorp/zero";
import type { ConnectorMembershipUsageType } from "../../shared/connectorUsagePolicies";
import { connectorIdsBySpace } from "../../shared/liveConnectorUsage";
import { queries } from "../../shared/queries";

export function connectorMembershipQueries(spaceId: string) {
  return {
    commit_step: queries.connectorUsagesBySpace({ spaceIds: [spaceId] }),
    space_git_remote: queries.loadSpaceGitRemote({ spaceId }),
  } satisfies Record<ConnectorMembershipUsageType, unknown>;
}

export type ConnectorMembershipData = {
  [T in ConnectorMembershipUsageType]: QueryResultType<
    ReturnType<typeof connectorMembershipQueries>[T]
  >;
};

const connectorMembershipSelectors = {
  commit_step: ({ commit_step }) =>
    [...connectorIdsBySpace(commit_step).values()].flatMap((ids) => [...ids]),
  space_git_remote: ({ space_git_remote }) =>
    space_git_remote?.appUsage
      ? [space_git_remote.appUsage.connectedAppId]
      : [],
} satisfies Record<
  ConnectorMembershipUsageType,
  (data: ConnectorMembershipData) => readonly string[]
>;

export function usedConnectorsForSpace<T extends { id: string }>(
  connectors: readonly T[],
  data: ConnectorMembershipData
): T[] {
  const ids = new Set(
    Object.values(connectorMembershipSelectors).flatMap((select) =>
      select(data)
    )
  );
  return connectors.filter((connector) => ids.has(connector.id));
}
